<template>
    <fragment>
        <!-- Grid Count-->
        <div class="grid_total" v-if="isTotalCount">
            Total&nbsp;Count&nbsp;
            <em>{{ totalCount | numberFormat }}</em>
        </div>
        <grid
            v-if="gridId != null && gridId != ''"
            :id="gridId"
            :ref="gridId"
            :data="gridProps.data"
            :columns="gridProps.columns"
            :options="gridProps.options"
            :pageOptions="gridProps.pageOptions"
            :theme="gridProps.theme"
            :language="gridProps.language"
            :isTotalCount="isTotalCount"
            :header="gridProps.header"
            @click="onClick"
            @check="onCheck"
            @uncheck="onUncheck"
            @dblclick="onDblclick"
            @mouseover="onMouseover"
            @mouseout="onMouseout"
            @mousedown="onMousedown"
            @focusChange="onFocusChange"
            @expande="onExpande"
            @collapse="onCollapse"
            @beforeRequest="onBeforeRequest"
            @response="onResponse"
            @successResponse="onSuccessResponse"
            @failResponse="onFailResponse"
            @errorResponse="onErrorResponse"
            @selection="onSelection"
        />
    </fragment>
</template>

<script>

/**
 * Toast Grid
 * ----------
 * Reference Doc
 * https://github.com/nhn/tui.grid/blob/master/packages/toast-ui.vue-grid/docs/getting-started.md
 */
import { Grid }                 from '@toast-ui/vue-grid'

import { mapGetters }           from 'vuex';
import _                        from 'lodash';
import $                        from 'jquery';
import axios                    from 'axios';
import qs                       from 'query-string';
import store                    from '@/vuex/store';
import SDLLocale                from '@/mixin/SDLLocale';
import { SDLUtil, StringUtil }  from '@/utils';
import { EventBus }             from '@/utils/EventBus';

/* 컴포넌트에서 사용할 스크립트 */
export default {
    name : 'KnowledgeModelGrid',
    components: {
        'grid' : Grid
    },
    props : {
        'gridId'        : { required : true },
        'columns'       : { type : Array, default : [] },
        'data'          : { type : Array, default : [] },
        'options'       : { type : Object },
        'header'        : { type : Object },
        'pageOptions'   : { type : Object },
        'theme'         : { type : [String, Object], default: 'clean' },
        'language'      : { type : String, default : SDLUtil.getI18nLanguage() || 'en'},
        'click'         : { type : Function },
        'isTotalCount'  : { defult : false }
    },
    data() {
        return {
            totalCount: 0
        }
    },
    computed: {
        ...mapGetters({
            locale: 'getLocale',
        }),
        getColumns() {
            return this.columns;
        }
    },
    watch: {
        totalCount(newTotCnt) {
            this.totalCount = newTotCnt;
            this.$emit('grid-total-count', newTotCnt);
        }
    },
    methods: {
        onClick(e) {
            if ((typeof e.rowKey) === "undefined") return;
            if(e.targetType == "cell") {
                // Occurs when a mouse button is clicked on the Grid.
                let rowData = this.$refs[this.gridId].invoke('getData');
                if(!SDLUtil.isNull(this.click)) this.click(e, rowData, this.$refs[this.gridId]);
                // this.$log.info('＃ KnowledgeModelGrid.vue call Click => ', rowData, rowData[e.rowKey]);

            } else {
                return false;
            }

        },
        onCheck(e) {
            // Occurs when a checkbox in row header is checked.
            /*
            let rowData = this.$refs[this.gridId].invoke('getData');
            console.log('onCheck - ' + e.rowKey, rowData[e.rowKey]);
            */
        },
        onUncheck(e) {
            console.log('onUncheck - ', e);
            // Occurs when a checkbox in row header is unchecked.
            /*
            let rowData = this.$refs[this.gridId].invoke('getData');
            console.log('onUncheck - ' + e.rowKey, rowData[e.rowKey]);
            */
        },
        onDblclick(e) {
            // Occurs when a mouse button is double clicked on the Grid.
            /*
            if ((typeof e.rowKey) === "undefined") return;
            let rowData = this.$refs[this.gridId].invoke('getData');
            console.log('onDblclick - ' + e.rowKey, rowData[e.rowKey]);
            */
        },
        onMouseover(e) {
            // Occurs when a mouse pointer is moved onto the Grid.
        },
        onMouseout(e) {
            // Occurs when a mouse pointer is moved off from the Grid.
        },
        onMousedown(e) {
            // Occurs when a mouse button is downed on the Grid.
        },
        onFocusChange(e) {
            let grid = this.$refs[this.gridId];
            let gridCols = grid.invoke('getColumns');
            // Occurs when focused cell is about to change.
            /*
            this.$refs[this.gridId].invoke('setSelectionRange', {
                start: [e.rowKey, 0],
                end: [e.rowKey, gridCols.length]
            });
            */
        },
        onExpande(e) {
            // Occurs when the row having child rows is expanded.
        },
        onCollapse(e) {
            // Occurs when the row having child rows is collapsed.
        },
        onBeforeRequest(e) {
            // Occurs before the http request is sent.
        },
        onResponse(e) {
            // Occurs when the response is received from the server.
        },
        onSuccessResponse(e) {
            // Occurs after the response event, if the result is true.
        },
        onFailResponse(e) {
            // Occurs after the response event, if the result is false.
        },
        onErrorResponse(e) {
            // Occurs after the response event, if the response is Error.
        },
        onSelection(e) {
            // Occurs when selecting cells.
        },
        loadPropsData(gridData = []) {
            // loadPropsData 에 gridData 가 들어오면 gridData 우선, 아닌 경우 gridProps 를 찾는다.
            if(gridData.length > 0) {
                this.$log.info('＃ KnowledgeModelGrid.vue call gridData => ', gridData);
                this.gridProps.data = gridData;
                this.totalCount = gridData.length;
                this.$refs[this.gridId].invoke('resetData', this.gridProps.data);

            } else if(this.gridProps.data.length > 0) {
                this.$log.info('＃ KnowledgeModelGrid.vue call loadPropsData => ', this.gridProps.data);
                this.totalCount = this.gridProps.data.length;
                this.$refs[this.gridId].invoke('resetData', this.gridProps.data);

            } else {
                this.$refs[this.gridId].invoke('resetData', []);
            }
        },
        /**
         *  grid setColumns
         *  @param (array) columns
         */
        setColumns(newCols = []) {
            if(SDLUtil.isNull(newCols)) {
                return false;
            };

            this.$refs[this.gridId].invoke('setColumns', newCols);
            this.$refs[this.gridId].invoke('refreshLayout');
        },
        loadData(gridData = []) {
            SDLUtil.showLoadingBar(true);

            this.loadPropsData(gridData);

            SDLUtil.showLoadingBar(false);
        },
        refreshGrid() {
            this.$refs[this.gridId].invoke('refreshLayout');
        },
        getGrid() {
            return this.$refs[this.gridId];
        },
        addRowClassName(rowKey, className) {
            // 패런트에서 코멘트된 코드와 같이 사용하면 됨.
            // this.$nextTick(() => {
            //     this.$refs.gridBulletin.addRowClassName('1', 'cell-red');
            // });
            this.$refs[this.gridId].invoke('addRowClassName', rowKey, className);
        },
    },
    created() {
        this.$log.info('＃ KnowledgeModelGrid.vue created => ', this.gridId);
        this.gridProps = {
            data: this.data,
            columns: this.columns,
            options: Object.assign(
                {
                    bodyHeight: 'auto',
                    rowHeight: 48,
                    selectionUnit: ['row'],
                    useClientSort: true,
                    showDummyRows: true,
                },
                this.options,
            ),
            header: this.header,
            columnOptions: {
                resizable: true,
            },
            pageOptions: this.pageOptions,
            theme: {
                name: 'clean',
                value: {
                    // required
                    row: {
                        hover: {
                            background: '#FBFBFC',
                        },
                    },
                },
            },
            language: {
                name: this.language,
                value: StringUtil.gridMessageMap(this.language),
            },
        };

        // 그리드가 그려져있는 DOM이 처음 화면 로딩시 display:none 일 경우, display 로 변경 때 호출 -> EventBus.$emit('grid-refresh');
        EventBus.$on('model-grid-refresh',    ()        => { this.refreshGrid(); });
        // 그리드 데이터 재정의
        EventBus.$on('model-grid-search',     gridData  => { this.loadData(gridData); });
        // 그리드 컬럼셋 변경 이벤트
        EventBus.$on('model-grid-set-column', newCols   => { this.setColumns(newCols); });
    },
    mounted() {
        this.loadData();
    },
    beforeDestroy(){
        // [필수] EventBus 를 통해 등록된 이벤트는 컴포넌트 종료시 반드시 종료한다.
        EventBus.$off('model-grid-refresh');
        EventBus.$off('model-grid-search');
        EventBus.$off('model-grid-set-column');
    }
};
</script>

<style>
td.ftColor > .tui-grid-cell-content {
    cursor: pointer;
    color: dodgerblue !important;
    text-decoration: none;
}
td.ftColor:hover > .tui-grid-cell-content {
    font-weight: bold !important;
    text-decoration: underline;
}
 .tui-grid-cell.cell-red {background-color: #fbcccc !important;}
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/knowledge/popup/KnowledgeModelGrid.vue